import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useTagsQuery } from "./useTagsQuery";
import type { TagEntityType } from "../../../zodios/apiDefinitions/api/tags";

export function useTagFilterOptions(entityType: TagEntityType, queryOptions?: { enabled?: boolean }) {
  const tagsQuery = useTagsQuery({ entityType }, queryOptions);
  const { t } = useTranslation(["tags"]);
  const options: { value: number | string; label: string }[] = useMemo(
    () => [
      { value: "all", label: t(($) => $.tags["All Tags"]) },
      ...(tagsQuery.data?.results.map((tag) => ({ value: tag.id, label: tag.name })) ?? []),
    ],
    [tagsQuery.data?.results, t],
  );
  return options;
}
